import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import usePointer from '../../services/pointer.js';
import useRaf from '../../services/raf.js';
import useResize from '../../services/resize.js';
import useScroll from '../../services/scroll.js';
import useKey from '../../services/key.js';
import useLoad from '../../services/load.js';
import { hasMethod } from '../utils.js';
var SERVICES_MAP = {
  scrolled: useScroll,
  resized: useResize,
  ticked: useRaf,
  moved: usePointer,
  keyed: useKey,
  loaded: useLoad
};
var SERVICE_NAMES = Object.keys(SERVICES_MAP);
export default class ServicesManager {
  get __services() {
    return _objectSpread(_objectSpread({}, this.__customServices), SERVICES_MAP);
  }

  constructor(instance) {
    _defineProperty(this, "__base", void 0);

    _defineProperty(this, "__customServices", {});

    Object.defineProperties(this, {
      __base: {
        enumerable: false,
        writable: false,
        value: instance
      }
    });
  }

  has(service) {
    if (!hasMethod(this.__base, service) && !this.__services[service]) {
      return false;
    }

    var {
      has
    } = this.__services[service]();

    return has(this.__base.$id);
  }

  enable(service) {
    if (this.has(service)) {
      return this.disable.bind(this, service);
    }

    if (!hasMethod(this.__base, service) || !this.__services[service]) {
      return function noop() {};
    }

    var {
      add
    } = this.__services[service]();

    var self = this;

    function serviceHandler() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      self.__base.__callMethod(service, ...args);
    }

    add(this.__base.$id, serviceHandler);
    return this.disable.bind(this, service);
  }

  enableAll() {
    return Object.keys(this.__services).map(serviceName => this.enable(serviceName));
  }

  disableAll() {
    Object.keys(this.__services).forEach(serviceName => {
      this.disable(serviceName);
    });
  }

  disable(service) {
    if (!this.__services[service]) {
      return;
    }

    var {
      remove
    } = this.__services[service]();

    remove(this.__base.$id);
  }

  register(name, useFunction) {
    this.__customServices[name] = useFunction;
  }

  unregister(name) {
    if (SERVICE_NAMES.includes(name)) {
      throw new Error("[ServicesManager] The `".concat(name, "` core service can not be unregistered."));
    }

    delete this.__customServices[name];
  }

}